module.exports = __webpack_public_path__ + "img/Moldova_GP1.9812a2b1.jpg";